import { cloneDeep } from 'lodash';
import { Store } from './Store';

const DEFAULT_LOADOUT = {
	name: '',
	cards: [
		{ empty: true },
		{ empty: true },
		{ empty: true }
	]
};

class LoadoutStore extends Store {
	data() {
		return cloneDeep(DEFAULT_LOADOUT);
	}

	clear() {
		Object.assign(this.state, cloneDeep(DEFAULT_LOADOUT));
		delete this.state._model;
	}

	reset() {
		if (this.state._model)
			this.set(this.state._model);
		else
			this.clear();
	}

	set(loadout) {
		Object.assign(this.state, cloneDeep(loadout));
		this.state._model = loadout;
	}

	save() {
		if (!('_model' in this.state)) {
			Object.assign(this.state, {
				id: Date.now()
			});
			this.state._model = cloneDeep(this.state);
		} else {
			for (const key in this.state._model)
				this.state._model[key] = cloneDeep(this.state[key]);
		}
	}

	get id() {
		return this.state._model?.id;
	}

	setName(name) {
		this.state.name = name;
	}

	toggleCardR5(cardIndex) {
		this.state.cards[cardIndex].r5 = !this.state.cards[cardIndex].r5;
	}

	addCard(card) {
		for (const i in this.state.cards) {
			if (this.state.cards[i].empty) {
				this.state.cards[i] = { r5: false, model: card };
				break;
			}
		}
	}

	placeCard(slotId, card) {
		const oldCard = this.state.cards[slotId];
		if (oldCard.r5 !== card.r5 || oldCard.model !== card.model)
			this.state.cards[slotId] = card;
	}

	removeCard(cardIndex) {
		if (cardIndex in this.state.cards)
			this.state.cards[cardIndex] = { empty: true };
	}
}
export const loadoutStore = new LoadoutStore('LOADOUT_STORE');
